export const loginPath = "/login";
export const signupPath = "/signup";
export const forgotPath ="/forgot";